export function isReachBasedScreenSaver(): boolean {
    return (
        typeof REACH !== 'undefined' &&
        typeof REACH.Application?.IsScreenSaverMode !== 'undefined' &&
        REACH.Application.IsScreenSaverMode()
    );
}
